<section id="secao-editais">
  <div class="container area-editais">
    <div class="titulo-editais">
      <h3>Editais Abertos</h3>
    </div>
    <div class="descricao-editais">
      <p>
        Responda ao
        <a href="https://www.seusite.com/seu-link" target="_blank" class="link-formulario">formulário</a>
        e confira os editais.
      </p>
    </div>
  </div>
</section>
